<template>
  <div>
    <input ref="picture" accept="image/*" type="file" @change="change($event)" />
    <div class="my-3">
      <img width="100px" v-if="cropped" :src="cropped" />
    </div>
    <v-dialog
      v-if="dialog"
      v-model="showDialog"
      hide-overlay
      persistent
      content-class="second-dialog"
      width="600"
    >
      <v-card>
        <vue-croppie
          ref="croppieRef"
          :enableOrientation="true"
          :boundary="{ width: 600, height: 600 }"
          :viewport="{ width: 200, height: 200, type: 'circle' }"
        ></vue-croppie>
        <v-card-actions>
          <v-btn depressed small @click="cancel" class="btn-custom--grey">{{ $gettext('Cancel') }}</v-btn>

          <v-spacer></v-spacer>
          <v-btn color="primary" dark depressed small @click="crop">
            <i class="fal fa-save" />
            {{ $gettext('Save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "PosCropImageUpload",
  props: {
    value: { type: [String, File], default: "" }
  },
  watch: {
    dialog() {
      this.$nextTick(() => {
        this.setAndRemoveZIndexDialog();
      });
    },
    value() {
      this.cropped =
        this.value && this.value.search("base64") != -1
          ? this.value
          : this.value
          ? location.protocol + "//" + location.hostname + "/api/" + this.value
          : "";
    }
  },
  data() {
    return {
      cropped: null,
      dialog: false,
      showDialog: true
    };
  },
  methods: {
    change(e) {
      this.$nextTick(() => {
        this.dialog = true;
      });
      this.convertBase64(e.target.files[0]).then(img => {
        this.$refs.croppieRef.bind({
          url: img,
          point: [0, 0, 0, 0]
        });
      });
    },
    setAndRemoveZIndexDialog() {
      if (this.dialog) {
        let dialogs = document.getElementsByClassName(
          "v-dialog__content--active"
        );
        for (let dialog of dialogs) {
          let elementExists = dialog.getElementsByClassName("second-dialog");
          if (elementExists.length != 0) {
            dialog.classList.add("z-index-100-important");
          }
        }
      } else {
        let dialogs = document.getElementsByClassName("z-index-100-important");
        for (let dialog of dialogs) {
          dialog.classList.remove("z-index-100-important");
        }
      }
    },
    convertBase64(file) {
      return new Promise((resolve, reject) => {
        var reader = new FileReader();
        reader.addEventListener(
          "load",
          function() {
            resolve(reader.result);
          },
          function() {
            reject("error");
          }
        );

        if (file) {
          reader.readAsDataURL(file);
        }
      });
    },
    cancel() {
      this.$refs.picture.value = "";
      this.$nextTick(() => {
        this.dialog = false;
      });
    },
    crop() {
      this.$refs.picture.value = "";
      this.$nextTick(() => {
        this.dialog = false;
      });
      let options = {
        format: "canvas",
        circle: true
      };
      this.$refs.croppieRef.result(options, output => {
        this.cropped = output;
        this.$emit("input", this.cropped);
      });
    },
    result(output) {
      this.cropped = output;
    },
    update(data) {
      console.log(data);
    }
  }
};
</script>
<style lang="scss" scoped>
.z-index-100-important {
  z-index: 100 !important;
}
</style>
